/**
 * 利用規約ページ（公開）
 * Sign Extension for クラウドサイン 利用規約
 */
import { PublicHeader, PublicFooter } from "./LandingPage.js";

const PRIMARY = "#534AB7";

export default function TermsPage() {
  return (
    <div style={{ fontFamily: "system-ui, -apple-system, sans-serif", color: "#1a1a1a", background: "white" }}>
      <PublicHeader minimal />

      <section style={{ background: "linear-gradient(135deg, #534AB7 0%, #7F77DD 100%)", color: "white", padding: "60px 24px 50px", textAlign: "center" }}>
        <h1 style={{ fontSize: 36, fontWeight: 800, marginBottom: 12 }}>利用規約</h1>
        <p style={{ fontSize: 15, opacity: 0.95 }}>Sign Extension for クラウドサイン</p>
      </section>

      <section style={{ padding: "60px 24px", background: "#faf9f7" }}>
        <div style={{ maxWidth: 820, margin: "0 auto", background: "white", borderRadius: 12, padding: "48px 40px", lineHeight: 2, fontSize: 14 }}>
          <p style={{ marginBottom: 24 }}>
            この利用規約（以下「本規約」といいます。）は、ナウビレッジ株式会社（以下「当社」といいます。）が提供する Sign Extension for クラウドサイン（第2条で定義します。以下「本サービス」といいます。）を利用するユーザー（第2条で定義します。）に適用されます。本サービスの名称又は内容が変更された場合は、当該変更後のサービスを含むものとします。ユーザーは、本規約に同意の上、本サービスを利用するものとします。
          </p>

          <Article title="第1条（目的）">
            <p>この利用規約（以下「本規約」といいます。）は、ナウビレッジ株式会社（以下「当社」といいます。）が提供する Sign Extension for クラウドサイン（第2条で定義します。以下「本サービス」といいます。）を利用するユーザー（第2条で定義します。）に適用されます。本サービスの名称又は内容が変更された場合は、当該変更後のサービスを含むものとします。ユーザーは、本規約に同意の上、本サービスを利用するものとします。</p>
            <p>本規約は、本サービスの利用条件を定めています。本サービスにユーザー登録したユーザーは全て本規約に従い、本規約の定める条件に従って本サービスを利用します。</p>
            <p>ユーザーが当社所定のオンライン申込手続を完了した時点で、当社とユーザーの間に本契約（第2条で定義します。）が成立します。</p>
            <p>本サービスの内容は、本規約その他当社がユーザーに対して通知又は公表する書面（電磁的記録を含みます。以下同様。）に記載されます。</p>
            <p>本サービスは HubSpot, Inc. その他の第三者が提供する製品と連携して動作しますが、これらの事業者とは独立して提供されるものであり、いずれの事業者による保証又はサポートの対象でもありません。</p>
            <p>本サービスは、ユーザーがクラウドサインを通じて電子契約を送信するための技術的な仲介機能を提供するものであり、当社は電子署名法（電子署名及び認証業務に関する法律）に基づく認証業務を行うものではありません。電子署名・電子認証の法的効力及びこれに関する責任は、クラウドサインの提供者及びユーザーに帰属します。</p>
            <p>当社が本サービスに関して別途定めるガイドライン、マニュアル、個別規定その他の細則等がある場合、当該細則等は本規約の一部を構成するものとし、本規約とこれら細則等の内容が矛盾する場合には、当該細則等の定めが優先して適用されるものとします。</p>
          </Article>

          <Article title="第2条（定義）">
            <p>本規約において使用する以下の用語は、以下の各号に定める意味を有します。</p>
            <dl style={defList}>
              <dt>「本サービス」</dt>
              <dd>当社が提供する Sign Extension for クラウドサイン をいいます。Sign Extension for クラウドサインは、ユーザーが利用する HubSpot アカウントとクラウドサイン（弁護士ドットコム株式会社が提供する電子契約サービス）を連携し、HubSpot CRM 上から電子契約の送信、署名ステータスの自動同期、締結済みファイルの格納等の機能を提供する Web アプリケーションです。本サービスの具体的な機能及び仕様は、当社が別途定め、ユーザーに対して通知又は公表するものとします。</dd>
              <dt>「本契約」</dt>
              <dd>本規約を契約条件とする、本サービスの利用に関する契約をいいます。</dd>
              <dt>「ユーザー」</dt>
              <dd>本規約に同意し、事業として本サービスを利用する法人又は個人事業主その他の事業者をいいます。</dd>
              <dt>「ユーザー情報」</dt>
              <dd>本サービスに登録したユーザーの ID、パスワードその他の認証に関する情報を指します。</dd>
              <dt>「通信機器」</dt>
              <dd>スマートフォン、タブレット端末及びコンピューター機器を指します。</dd>
              <dt>「外部サービス」</dt>
              <dd>HubSpot、クラウドサイン（弁護士ドットコム株式会社）、Google、Stripe、Resend その他の第三者が提供するサービスであって、本サービスと連携し、又は本サービスの提供に利用されるものを指します。</dd>
              <dt>「同期データ」</dt>
              <dd>本サービスにおいてユーザーの HubSpot アカウントから取得し、当社のサーバーに保存されるデータ（電子契約の送信ログ（書類 ID、送信ステータス、送信日時、宛先数等）、HubSpot レコードの識別情報、本サービスの機能提供に必要なレコードのプロパティ値等を含みます。なお、宛先の氏名・メールアドレス等の個人情報はサーバーに保存せず、送信時にのみ利用します。）を指します。</dd>
              <dt>「ユーザーデータ」</dt>
              <dd>本サービスの利用を通じて作成、保存又は処理されるすべてのデータ（同期データを含みます。）をいいます。</dd>
            </dl>
          </Article>

          <Article title="第3条（ユーザー登録）">
            <ol style={olStyle}>
              <li>本サービスの利用を希望する者は、本規約の内容に同意の上、当社が定める手続によりユーザー登録を行うものとし、登録に際しては自らに関する正確かつ最新の情報を提供するものとします。</li>
              <li>ユーザーは、前項に基づき登録した情報に変更が発生した場合、直ちに、登録情報の変更手続を行う義務を負います。</li>
              <li>当社は、本サービスの登録希望者が以下の各号のいずれかに該当すると判断した場合、当社の裁量により、ユーザー登録を拒否する場合があります。この場合、当社は、当該登録希望者に対して、登録拒否の理由を説明する義務を負いません。
                <ol style={olStyleNested}>
                  <li>ユーザーが既に登録済みである場合</li>
                  <li>第三者に本サービスを利用させることを目的として登録しようとする場合</li>
                  <li>過去に本規約に違反したことがある場合</li>
                  <li>登録のために提供された情報に不正確又は虚偽と疑われる情報が含まれている場合</li>
                  <li>第20条の保証に違反する事実が認められる場合</li>
                  <li>有効な HubSpot アカウントを保有していない場合</li>
                  <li>その他当社がユーザーによる本サービスの利用が不適切であると判断する場合</li>
                </ol>
              </li>
              <li>ユーザーは、本サービス上のアカウントを第三者に対して利用、貸与、譲渡、売買又は質入等をすることはできません。</li>
            </ol>
          </Article>

          <Article title="第4条（本契約の契約期間）">
            <ol style={olStyle}>
              <li>無料トライアル期間中の本契約の有効期間は、ユーザー登録が完了した日から無料トライアル期間の終了日までとします。</li>
              <li>ユーザーが当社所定の方法により有料プランへ申込みを行った日（以下「契約開始日」といいます。）から1か月間を、有料プランに基づく本契約の有効期間とします。</li>
              <li>有効期間満了日までに、ユーザー又は当社のいずれからも解約の手続がなされない場合、本契約は同一条件で1か月間更新されるものとし、以後も同様とします。</li>
            </ol>
          </Article>

          <Article title="第5条（利用料金）">
            <ol style={olStyle}>
              <li>本サービスの利用料金は、以下のプランに基づきます。Starter プラン：月額 4,980 円（税別）、Professional プラン：月額 9,800 円（税別）、Enterprise プラン：月額 19,800 円（税別）。各プランの送信件数上限その他の詳細は、当社ウェブサイトに掲載するものとします。</li>
              <li>ユーザーは、当社が定める方法で、本サービスの利用料金及びこれにかかる消費税等を、当社に対し支払うものとします。</li>
              <li>当社は、新規ユーザー登録時に、14 日間の無料トライアルを提供します。無料トライアル期間の終了後、ユーザーが有料プランの申込みを行わない場合、本サービスの全部又は一部の利用が制限されます。無料トライアル期間の終了により自動的に課金されることはありません。</li>
              <li>無料トライアル期間中であっても、本規約のうち利用料金及び決済に関する規定を除き、本サービスの利用に関するその他の規定はすべて適用されるものとします。</li>
              <li>本サービスの利用料金の決済は、当社が指定する外部の決済サービスを通じて行われます。ユーザーは、当該決済サービスの利用規約に同意の上、決済手続を行うものとします。</li>
              <li>前項の規定にかかわらず、当社が承認した場合、ユーザーは当社が発行する請求書に基づき利用料金を支払うことができます。この場合の支払条件は、当社とユーザーの間で別途締結する合意書面によるものとします。</li>
              <li>支払済みの利用料金は、理由の如何を問わず返金されません。</li>
            </ol>
          </Article>

          <Article title="第6条（ユーザー情報、通信機器等に関する管理）">
            <ol style={olStyle}>
              <li>ユーザーは、本サービスの提供を受けるために必要な機器、通信手段等の環境を全て自らの費用と責任で備えます。また、本サービスの利用にあたり必要となる通信費用は、全てユーザーの負担とします。</li>
              <li>ユーザーは、ユーザー情報及び通信機器の管理責任を負います。ユーザー情報及び通信機器の管理不十分、使用上の過誤、第三者の使用等、並びにユーザーが本サービスに関して登録した決済手段、金融機関の情報その他の当社に提供した情報（以下「提供情報」といいます。）の過誤、第三者の利用等による損害の責任はユーザーが負い、当社は当社に故意又は重過失のない限り一切の責任を負いません。</li>
              <li>ユーザーは、ユーザー情報、提供情報又は通信機器を第三者に使用されるおそれのある場合は、直ちに当社にその旨を連絡するとともに、当社の指示があるときはこれに従います。</li>
              <li>ユーザーは、自己の責任において、本サービスのアカウント、ID 及びパスワードを適切に管理・保管し、第三者に利用させ、又は貸与、譲渡、売買若しくは担保提供してはなりません。</li>
              <li>当社は、ログイン時に使用された ID 及びパスワードが登録されたものと一致することを所定の方法により確認した場合、当該ログインについてユーザー本人による利用とみなし、これにより生じた結果について当社は責任を負わないものとします。</li>
            </ol>
          </Article>

          <Article title="第7条（HubSpot 及びクラウドサインとの連携）">
            <ol style={olStyle}>
              <li>本サービスを利用するためには、ユーザーが管理する HubSpot アカウント及びクラウドサインのアカウントと本サービスを連携させる必要があります。ユーザーは、本サービスの申込み及び利用にあたり、本サービスが当該 HubSpot アカウント及びクラウドサインアカウントに対して、連携に必要な範囲で API を通じてアクセスし、データを取得、保存、表示、送信その他の処理を行うことを承認し、これに必要な権限を付与するものとします。ユーザーは、クラウドサインのクライアント ID を本サービスに登録するものとし、当該クライアント ID は AES-256-GCM 方式により暗号化して保存されます。</li>
              <li>ユーザーが前項に定める権限付与を行わない場合、又は当該権限を途中で取り消した場合には、本サービスの全部又は一部が利用できなくなることがあります。この場合にユーザーに生じた損害について、当社は一切の責任を負いません。</li>
              <li>HubSpot 又はクラウドサインの仕様変更、API 利用条件の変更、機能制限、サービス停止その他当社の責に帰さない事由により、本サービスの全部又は一部が利用できなくなった場合であっても、当社は一切の責任を負いません。</li>
            </ol>
          </Article>

          <Article title="第8条（サービスレベル）">
            <ol style={olStyle}>
              <li>当社は、本サービスの月間稼働率 99.5% を目標として運用しますが、これを保証するものではありません。</li>
              <li>計画的なメンテナンスは、原則として日本時間の深夜帯（午前 1 時から午前 5 時）に実施し、7 日前までに、当社ウェブサイトへの掲載又は電子メールその他当社所定の方法によりユーザーに通知します。</li>
              <li>HubSpot、クラウドサイン、Stripe その他の外部サービスのメンテナンス、仕様変更、障害等により本サービスが利用できない場合、当社は責任を負いません。</li>
            </ol>
          </Article>

          <Article title="第9条（知的財産権等）">
            <ol style={olStyle}>
              <li>本サービスにおいて提供される全ての情報及びコンテンツ（以下総称して「当社コンテンツ」といいます。）に関する著作権、特許権、実用新案権、商標権、意匠権その他一切の知的財産権及びこれらの権利の登録を受ける権利（以下総称して「知的財産権」といいます。）は、当社又は当社がライセンスを受けているライセンサーに帰属し、ユーザーには帰属しません。本規約に基づく本サービスの利用の許諾は、本サービスの利用を超えた当社コンテンツに関する知的財産権の利用を許諾するものではなく、ユーザーは、当社コンテンツについて、複製、配布、転載、転送、公衆送信、改変、翻案その他の二次利用等を行ってはなりません。</li>
              <li>ユーザーが本条の規定に違反して問題が発生した場合、ユーザーは、自己の費用と責任において当該問題を解決するとともに、当社に何らの不利益、負担又は損害を与えないよう適切な措置を講じなければなりません。</li>
            </ol>
          </Article>

          <Article title="第10条（導入事例等の公開）">
            <p>当社がマーケティング等の目的で、ユーザーが本サービスの利用者である旨若しくはその利用状況等を当社ウェブサイト、営業資料等に記載する場合には、事前にユーザーへ連絡し、その使用又は記載について確認を行うものとします。ユーザーは、当該使用又は記載の差し止め若しくは修正を求めることができます。</p>
          </Article>

          <Article title="第11条（禁止事項）">
            <p>当社は、ユーザーによる本サービスの利用に際して、以下の各号に定める行為を禁止します。</p>
            <ol style={olStyle}>
              <li>本規約に違反する行為</li>
              <li>当社、当社がライセンスを受けているライセンサーその他第三者の知的財産権、肖像権等の財産的又は人格的な権利を侵害する行為又はこれらを侵害するおそれのある行為</li>
              <li>当社又は第三者に不利益若しくは損害を与える行為又はそのおそれのある行為</li>
              <li>不当に他人の名誉や権利、信用を傷つける行為又はそのおそれのある行為</li>
              <li>法令又は条例等に違反する行為</li>
              <li>公序良俗に反する行為若しくはそのおそれのある行為又は公序良俗に反するおそれのある情報を他のユーザー又は第三者に提供する行為</li>
              <li>犯罪行為、犯罪行為に結びつく行為若しくはこれを助長する行為又はそのおそれのある行為</li>
              <li>事実に反する情報又は事実に反するおそれのある情報を提供する行為</li>
              <li>当社のシステムへの不正アクセス、それに伴うプログラムコードの改ざん、位置情報の改ざん、故意に虚偽、通信機器の仕様その他アプリケーションを利用してのチート行為、コンピューターウィルスの頒布その他本サービスの正常な運営を妨げる行為又はそのおそれのある行為</li>
              <li>当社が提供する本サービスの機能の範囲を超えて、マクロその他操作を自動化する機能やツール等を使用する行為</li>
              <li>当社が提供するソフトウェアその他のシステムに対する逆コンパイル、逆アセンブル、リバースエンジニアリングその他の解析行為</li>
              <li>本サービスの信用を損なう行為又はそのおそれのある行為</li>
              <li>他のユーザーのアカウントの使用その他の方法により、第三者になりすまして本サービスを利用する行為</li>
              <li>詐欺、預貯金口座及び携帯電話の違法な売買等の犯罪に結びつく又は結びつくおそれのある行為</li>
              <li>犯罪収益に関する行為、テロ資金供与に関する行為又はその疑いがある行為</li>
              <li>HubSpot の利用規約若しくは API 利用規約、又はクラウドサインの利用規約に違反する行為</li>
              <li>その他当社が不適当と判断する行為</li>
            </ol>
          </Article>

          <Article title="第12条（解除）">
            <ol style={olStyle}>
              <li>当社は、ユーザーが以下の各号のいずれかに該当した場合、何らの通知等を要することなく、本サービスの全部若しくは一部の利用を停止させ、又は本契約を解除し、本サービスを退会させることができます。この場合、当社は、ユーザーに対して、当該措置を講じた理由を説明する義務を負いません。
                <ol style={olStyleNested}>
                  <li>本規約のいずれかの条項に違反した場合</li>
                  <li>本規約に基づく債務が履行されない場合</li>
                  <li>第3条第3項各号のいずれかに該当する場合</li>
                  <li>登録情報に虚偽の情報が含まれている場合</li>
                  <li>過去に当社から退会処分を受けていた場合</li>
                  <li>支払停止若しくは支払不能となり、又は破産手続開始、民事再生手続開始、会社更生手続開始、特別清算開始若しくはこれらに類する手続の開始の申し立てがあった場合</li>
                  <li>解散又は営業停止した場合</li>
                  <li>ユーザーの相続人等からユーザーが死亡した旨の連絡があった場合又は当社がユーザーの死亡の事実を確認できた場合</li>
                  <li>未成年が法定代理人の同意なく、本サービスを利用した場合</li>
                  <li>成年被後見人、被保佐人又は被補助人が、成年後見人、保佐人又は補助人等の同意なく、本サービスを利用した場合</li>
                  <li>当社からの要請に対し誠実に対応しない場合</li>
                  <li>HubSpot アカウント又はクラウドサインアカウントが無効となった場合</li>
                  <li>その他当社が不適当と判断した場合</li>
                </ol>
              </li>
              <li>ユーザーが契約プランの変更等の本契約の内容の変更又は退会を希望する場合、当社が定める手続により、本契約の内容を変更、又は本契約を解除し、本サービスを退会することができます。退会の手続が完了した場合であっても、当該時点における請求期間の終了日までは本サービスを利用することができます。ただし、当社は、支払済みの利用料金その他いかなる金銭の返還も行いません。</li>
              <li>第1項及び第2項により本サービスを退会したユーザーは、退会時に期限の利益を喪失し、直ちに、当社に対し負担する全ての債務を履行します。また、再度本サービスの登録を行った際に、退会前の情報が引き継がれないことがあることをあらかじめ了承するものとします。</li>
            </ol>
          </Article>

          <Article title="第13条(非保証・免責)">
            <ol style={olStyle}>
              <li>当社は、本サービスの完全性、正確性、有用性及び有効性等について、一切の保証をしません。また、当社は、本サービスに中断、中止その他の障害が生じないことを保証しません。</li>
              <li>本サービスは、外部サービスと連携して機能を提供します。外部サービスの仕様変更、障害、サービス停止、API の提供条件の変更その他外部サービスに起因又は関連する事由により、本サービスの全部又は一部が利用できなくなった場合であっても、当社は一切の責任を負いません。</li>
              <li>ユーザーが本サービスを利用するにあたり、本サービスから外部サービスに遷移する場合があります。その場合、ユーザーは、自らの責任と負担で外部サービスの利用規約等に同意の上、本サービス及び外部サービスを利用します。なお、外部サービスの内容について、その完全性、正確性、有用性及び有効性等について、当社は一切の保証をしません。</li>
              <li>ユーザーは、外部サービスの利用にあたり、当該外部サービスの提供者が定める利用規約、プライバシーポリシーその他の条件に自らの責任で同意し、これを遵守するものとします。</li>
              <li>本サービスへのログインに利用する Google OAuth その他の外部認証サービスに起因する認証障害、アカウント停止その他のトラブルについて、当社は一切の責任を負いません。</li>
              <li>クラウドサインを通じて行われる電子契約の法的効力、有効性及び執行可能性については、クラウドサインの利用規約及び適用法令に従うものとし、当社はこれらについて一切の保証をしません。ユーザーは、電子契約の締結に関する判断及び行動について、自らの責任で行うものとします。</li>
              <li>ユーザーが登録情報の変更を行わなかったことにより損害を被った場合でも、当社は一切の責任を負いません。</li>
              <li>ユーザーは、法令の範囲内で本サービスをご利用ください。本サービスの利用に関連してユーザーが日本又は外国の法令に触れた場合でも、当社は一切の責任を負いません。</li>
              <li>当社が本規約及び当社が別途定めるセキュリティ基準に従い合理的な安全管理措置を講じていたにもかかわらず、予期しない不正アクセス等の行為によってユーザー情報を盗取された場合、それによって生じるユーザーの損害等に対して、当社は責任を負いません。</li>
              <li>当社は、天災、地変、火災、ストライキ、通商停止、戦争、内乱、感染症の流行その他の不可抗力により本契約の全部又は一部に不履行が発生した場合、一切の責任を負いません。</li>
              <li>本サービスの利用に関し、ユーザーが他のユーザーとの間でトラブル（本サービス内外を問いません。）になった場合でも、当社は一切の責任を負わず、ユーザー間のトラブルは、当該ユーザーが自らの費用と負担において解決します。</li>
              <li>本サービスの利用が、連携先（HubSpot、クラウドサイン等）の定める API 利用制限を超過した場合、一時的に機能が制限されることがありますが、当社はこれについて責任を負いません。</li>
              <li>本サービスを通じて締結された電子契約に関する電子帳簿保存法、電子署名法その他の関連法令の遵守については、ユーザーが自らの責任において行うものとし、当社は当該法令への適合性について一切の保証をしません。</li>
              <li>ユーザーが本サービスを通じて電子契約を送信するにあたり、宛先の指定、送付内容の決定、送付タイミング等は全てユーザーの責任において行うものとし、誤送信、宛先指定の誤り、送付内容の誤り等によりユーザー又は第三者に損害が生じた場合、当社は一切の責任を負いません。</li>
            </ol>
          </Article>

          <Article title="第14条（データの取扱い）">
            <ol style={olStyle}>
              <li>ユーザーデータの所有権は、ユーザーに帰属します。当社は、本サービスの提供に必要な範囲でのみユーザーデータにアクセスし、処理を行います。</li>
              <li>当社は、本サービスの提供にあたり、ユーザーの HubSpot アカウント及びクラウドサインアカウントと連携し、電子契約の送信ログ（書類 ID、送信ステータス、ファイル数、宛先数、送信日時等）をサーバーに保存します。また、本サービスの機能提供に必要な範囲で、HubSpot レコードのプロパティ値を参照し、ステータス等を書き込みます。暗号化対象データ（クラウドサインクライアント ID、HubSpot OAuth トークン）は AES-256-GCM 方式で暗号化して保存されます。</li>
              <li>電子契約の宛先の氏名・メールアドレス等の個人情報及び電子契約の文書本体（PDF ファイル等）は当社のサーバーに保存されず、クラウドサイン API への送信時にのみ使用され、又はクラウドサイン上で保管されます。電子契約文書の保管・証拠保全に関する責任は、クラウドサインの利用規約に従い、ユーザー自身に帰属します。</li>
              <li>当社は、同期データの正確性、完全性及び最新性について一切の保証をしません。HubSpot 上又はクラウドサイン上のデータの内容に起因する誤り又は不正確な表示について、当社は責任を負いません。</li>
              <li>当社は、同期データのバックアップを行う義務を負いません。ユーザーは、自らの責任でデータのバックアップを行うものとします。</li>
              <li>ユーザーがアカウントを削除した場合、当社は、当該ユーザーに関連するユーザーデータを速やかに削除します。ユーザーが本契約を解約した場合（アカウント削除を伴わない場合）、ユーザーデータは当社が別途定める期間保持された後に削除されます。ただし、法令により保存が義務付けられている場合はこの限りではありません。</li>
              <li>当社は、本サービスの提供に必要な範囲で、HubSpot が提供するユーザー ID、レコード ID、ユーザーのメールアドレス、並びにクラウドサインが提供する書類 ID、署名ステータスその他当社が別途定める情報及び本サービスの利用状況に関するログ情報を取得し、認証・アクセス制御、利用状況の記録、サポート対応、本サービスの品質改善及び不正利用の防止の目的で利用します。また、当社は、ユーザーデータ及び利用状況に関する情報を、個人を識別できない形式に加工したうえで、統計情報として当社サービスの改善、新サービスの企画・開発その他マーケティングの目的で利用することができるものとします。</li>
            </ol>
          </Article>

          <Article title="第15条（損害賠償責任）">
            <ol style={olStyle}>
              <li>ユーザーは、本規約の違反又は本サービスの利用に関連して当社に損害を与えた場合、当社に発生した損害（逸失利益及び弁護士費用を含みます。）を賠償します。</li>
              <li>当社が本サービスに関連してユーザーに対して損害賠償責任を負う場合であっても、当社の賠償責任は、当社の故意又は重過失に基づく場合を除き、ユーザーに現実に生じた通常の損害に限られるものとし、かつ、損害の事由が生じた時点から遡って直近 3 か月の期間にユーザーから現実に受領した本サービスの利用料金の総額を上限とします。</li>
            </ol>
          </Article>

          <Article title="第16条（本サービスの提供条件）">
            <p>当社は、以下の各号のいずれかに該当する場合、ユーザーに通知することなく、本サービスを停止又は変更することがあります。</p>
            <ol style={olStyle}>
              <li>本サービスの提供に必要となるコンピューター、サーバー、通信回線その他の設備（以下「本サービス設備」といいます。）の故障、障害、誤操作の発生、不正アクセス、過度なアクセスの集中その他の理由により本サービスの提供ができなくなった場合</li>
              <li>本サービス設備の点検、保守、修理又は変更等を行う場合</li>
              <li>天災、地変、火災、ストライキ、通商停止、戦争、内乱、感染症の流行その他の不可抗力により本サービスの提供ができなくなった場合</li>
              <li>法令又はこれに基づく措置により本サービスの提供ができなくなった場合</li>
              <li>本サービスの提供に必要となる第三者により提供されるサービス（HubSpot を含む）の全部又は一部の提供が停止又は中断された場合</li>
              <li>その他当社が停止又は変更を必要と判断した場合</li>
            </ol>
          </Article>

          <Article title="第17条（本サービスの廃止）">
            <ol style={olStyle}>
              <li>当社は、当社が本サービスの提供を廃止すべきと合理的に判断した場合、ユーザーに対して廃止日の 30 日前までに通知したうえで、本サービスの提供を廃止できます。ただし、法令上の要請その他やむを得ない事由がある場合は、この限りではありません。</li>
              <li>前項の場合、当社に故意又は重過失がある場合を除き、当社は一切の責任を負いません。</li>
            </ol>
          </Article>

          <Article title="第18条（遅延損害金）">
            <p>ユーザーが、当社の指定する期日までに当社に対する金銭債務の支払いを行わなかった場合は、支払期日の翌日から支払い済みに至るまで、年 14.6% の日割計算による遅延損害金を支払うものとします。</p>
          </Article>

          <Article title="第19条（秘密保持）">
            <ol style={olStyle}>
              <li>ユーザー及び当社は、本サービスの提供又は利用に関して知り得た相手方の秘密情報（本サービスに関するノウハウ、当社のシステムに関する情報、技術上又は営業上の一切の秘密情報を含みます。）を、厳重かつ適正に管理するものとし、相手方の事前の書面による同意なく第三者に開示、提供及び漏洩し、又は本サービスの提供若しくは利用の目的以外に使用してはならないものとします。</li>
              <li>次の各号の情報は、秘密情報に該当しないものとします。
                <ol style={olStyleNested}>
                  <li>開示を受けた時、既に所有していた情報</li>
                  <li>開示を受けた時、既に公知であった情報又はその後自己の責に帰さない事由により公知となった情報</li>
                  <li>開示を受けた後に、第三者から合法的に取得した情報</li>
                  <li>開示された秘密情報によらず独自に開発し又は創作した情報</li>
                </ol>
              </li>
              <li>ユーザー及び当社は、相手方の指示があった場合又は本契約が終了した場合は、相手方の指示に従い速やかに秘密情報を、原状に回復した上で返却又は廃棄し、以後使用しないものとします。</li>
              <li>第1項の規定にかかわらず、当社は、本サービスの提供に必要な範囲において、当社の関連会社又は委託先にユーザーの秘密情報を開示することができます。この場合、当社は当該関連会社又は委託先に対し、本条に定める秘密保持義務と同等の義務を課すとともに、必要かつ適切な監督を行います。</li>
              <li>当社は、本サービスを提供する目的のために、ユーザーの秘密情報を利用することができます。</li>
              <li>第1項の規定にかかわらず、当社は、法令、裁判所、行政庁又は規制権限を有する公的機関の規則、裁判、命令、指示等により秘密情報の開示を要求される場合、必要な範囲で秘密情報を開示することができます。</li>
              <li>本条に定める秘密保持義務は、本契約の終了後 3 年間存続するものとします。</li>
            </ol>
          </Article>

          <Article title="第20条（反社会的勢力の排除）">
            <ol style={olStyle}>
              <li>ユーザー及び当社は、現在、暴力団、暴力団員、暴力団員でなくなった時から 5 年を経過しない者、暴力団準構成員、暴力団関係企業、総会屋等、社会運動等標ぼうゴロ又は特殊知能暴力集団等、その他これらに準ずる者（以下総称して「暴力団員等」といいます。）に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを保証します。
                <ol style={olStyleNested}>
                  <li>暴力団員等が経営を支配していると認められる関係を有すること。</li>
                  <li>暴力団員等が経営に実質的に関与していると認められる関係を有すること。</li>
                  <li>自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってする等、不当に暴力団員等を利用していると認められる関係を有すること。</li>
                  <li>暴力団員等に対して資金等を提供し、又は便宜を供与する等の関与をしていると認められる関係を有すること。</li>
                  <li>役員又は経営に実質的に関与している者が暴力団員等と社会的に非難されるべき関係を有すること。</li>
                </ol>
              </li>
              <li>ユーザー及び当社は、自ら又は第三者を利用して次の各号のいずれかに該当する行為を行わないことを確約します。
                <ol style={olStyleNested}>
                  <li>暴力的な要求行為</li>
                  <li>法的な責任を超えた不当な要求行為</li>
                  <li>取引に関して、脅迫的な言動をし、又は暴力を用いる行為</li>
                  <li>風説を流布し、偽計を用い又は威力を用いて相手方の信用を毀損し、又は相手方の業務を妨害する行為</li>
                  <li>その他前各号に準ずる行為</li>
                </ol>
              </li>
              <li>ユーザー及び当社は、相手方が、暴力団員等若しくは第1項各号のいずれかに該当し、若しくは前項各号のいずれかに該当する行為をし、又は第1項の規定にもとづく表明・保証に関して虚偽の申告をしたことが判明した場合には、自己の責に帰すべき事由の有無を問わず、相手方に対して何らの催告をすることなく本契約を解除することができます。</li>
              <li>ユーザー及び当社は、前項により本契約を解除した場合、相手方に損害が生じたとしてもこれを一切賠償する責任はないことを確認し、これを了承します。</li>
            </ol>
          </Article>

          <Article title="第21条（お問い合わせ対応）">
            <ol style={olStyle}>
              <li>当社は、本サービスに関するユーザーからのお問い合わせに対して回答するよう努めますが、法令又は本規約上、当社に義務又は責任が発生する場合を除き、回答の義務を負いません。</li>
              <li>当社は、ユーザーからのお問い合わせに回答するか否かの基準を開示する義務を負いません。</li>
              <li>HubSpot 本体及びクラウドサイン本体に関するお問い合わせは、当社のサポート対象外となります。</li>
            </ol>
          </Article>

          <Article title="第22条（地位の譲渡等）">
            <ol style={olStyle}>
              <li>ユーザーは、当社の書面による事前の承諾なく、契約上の地位又は本規約に基づく権利若しくは義務につき、第三者に対し、譲渡、移転、担保設定、その他の処分をすることはできません。</li>
              <li>当社は本サービスにかかる事業を第三者に譲渡（事業譲渡、会社分割その他態様の如何を問わないものとします。）した場合には、当該譲渡に伴い本契約上の地位、本規約に基づく権利及び義務並びにユーザー情報その他の顧客情報を当該譲渡の譲受人に譲渡することができるものとし、ユーザーはかかる譲渡につき本項においてあらかじめ同意したものとします。</li>
            </ol>
          </Article>

          <Article title="第23条（個人情報の取扱い）">
            <ol style={olStyle}>
              <li>ユーザーは、本サービスの利用に際して第三者の個人情報を取り扱う場合、当該個人情報を機密として適切に管理し、第三者に開示又は漏洩してはならず、本サービスの利用目的の範囲を超えて利用してはならないものとします。</li>
              <li>当社は、本サービスの提供に関連して取得又はユーザーから委託を受けて取り扱う個人情報について、当社が別途定め、当社ウェブサイト上で公表する「<a href="/privacy" style={{ color: PRIMARY }}>個人情報の取扱いについて</a>」に従い、適切に取り扱うものとします。</li>
              <li>当社は、個人情報の取扱いの全部又は一部を第三者に委託する場合、当該委託先に対して個人情報の安全管理に関する契約上の義務を課し、必要かつ適切な監督を行うものとします。</li>
              <li>当社は、本サービスに関連して個人情報の漏えい、滅失又はき損その他の安全管理上の事故が発生したことを認識した場合、法令に従い必要な調査・措置を講じ、必要に応じてユーザーに対し速やかに通知します。</li>
              <li>ユーザーは、当社による個人情報の取扱いについて、当社のプライバシーポリシーの範囲内で合理的な説明を求めることができ、当社はこれに誠実に対応するものとします。</li>
              <li>本サービスの提供にあたり、当社がユーザーの個人データを取り扱う場合、当社は個人情報の保護に関する法律に基づく受託者として、法令及び当社が別途定めるセキュリティ基準に従い、適切な安全管理措置を講じるものとします。</li>
            </ol>
          </Article>

          <Article title="第24条（Cookie 等）">
            <ol style={olStyle}>
              <li>当社は、本サービスの品質向上、利用状況の分析等の目的で、Cookie、IP アドレス、アクセスログ等の情報を取得・利用する場合があります。ユーザーは、ブラウザの設定により Cookie の受入れを拒否することができますが、その場合、本サービスの一部の機能が利用できなくなることがあります。</li>
              <li>これらの情報の取扱いについては、「<a href="/privacy" style={{ color: PRIMARY }}>個人情報の取扱いについて</a>」に定めるところによります。</li>
            </ol>
          </Article>

          <Article title="第25条（分離可能性）">
            <ol style={olStyle}>
              <li>本規約の規定の一部が法令に基づいて無効と判断されても、本規約の他の規定は有効とします。</li>
              <li>本規約の規定の一部があるユーザーとの関係で無効又は取消となった場合でも、本規約は他のユーザーとの関係では有効とします。</li>
            </ol>
          </Article>

          <Article title="第26条（違反行為への対処方法）">
            <ol style={olStyle}>
              <li>ユーザーは、本規約に違反する行為を発見した場合は、当社にご連絡ください。</li>
              <li>ユーザーは、本規約に違反する行為への当社の対処について、異議を申し立てることはできません。</li>
            </ol>
          </Article>

          <Article title="第27条（存続条項）">
            <p>第6条、第9条、第12条第3項、第13条、第14条、第15条、第18条、第19条、第20条第4項、第22条、第23条、第24条、第26条、本条、第30条及び第31条の規定は、本契約の終了後も有効に存続するものとします。ただし、第19条については同条第7項に定める期間に限り、第23条及び第24条については、当社がユーザーデータの削除を完了するまでの間に限るものとします。</p>
          </Article>

          <Article title="第28条（規約変更及び通知）">
            <ol style={olStyle}>
              <li>当社が本サービスに関してユーザーに通知を行う必要があると判断した場合、本サービス上への表示、当社ウェブサイトへの掲載、電子メールその他当社所定の方法により行うものとします。</li>
              <li>当社が前項の方法により通知を行った場合、電子メールによる通知は当社が送信した時点で、ウェブサイト又は本サービス上への掲載による通知は当該内容を掲載した時点で、それぞれユーザーに到達したものとみなします。</li>
              <li>当社は、以下の各号のいずれかに該当する場合は、民法第548条の4の規定に基づき本規約を随時変更できます。本規約が変更された後の本契約は、変更後の本規約が適用されます。
                <ol style={olStyleNested}>
                  <li>本規約の変更が、ユーザーの一般の利益に適合するとき。</li>
                  <li>本規約の変更が、契約をした目的に反せず、かつ、変更の必要性、変更後の内容の相当性及びその内容その他の変更に係る事情に照らして合理的なものであるとき。</li>
                </ol>
              </li>
              <li>当社は、本規約の変更を行う場合は、変更後の本規約の効力発生時期を定め、あらかじめ、変更後の本規約の内容及び効力発生時期をユーザーに通知、本サービス上への表示その他当社所定の方法によりユーザーに周知します。</li>
              <li>前2項の規定にかかわらず、変更後の本規約の効力発生日以後にユーザーが本サービスを利用した場合、当該ユーザーは本規約の変更に同意したものとします。</li>
            </ol>
          </Article>

          <Article title="第29条（ベータ版の提供）">
            <ol style={olStyle}>
              <li>当社は、本サービスの全部又は一部をベータ版として提供することがあります。ベータ版は、機能の追加、変更又は廃止が予告なく行われる場合があり、ユーザーはこれをあらかじめ承諾するものとします。</li>
              <li>当社は、ベータ版として提供する本サービスについて、その完全性、安定性、正確性及び特定の目的への適合性を含め、一切の保証をしません。</li>
              <li>ベータ版の利用に起因又は関連してユーザーに生じた損害について、当社は、当社に故意又は重過失がある場合を除き、一切の責任を負いません。</li>
              <li>当社は、ベータ版の提供を、理由の如何を問わず、ユーザーへの事前の通知なく終了することができます。</li>
            </ol>
          </Article>

          <Article title="第30条（準拠法）">
            <p>本規約に関する準拠法は、全て日本国の法令が適用されます。</p>
          </Article>

          <Article title="第31条（合意管轄）">
            <p>ユーザーと当社との間における一切の訴訟は、東京地方裁判所を第一審の専属的合意管轄裁判所とします。</p>
          </Article>

          <Article title="第32条（協議解決）">
            <p>本規約に定めのない事項又は本規約の解釈に疑義が生じた事項については、ユーザー及び当社は誠意をもって協議の上、解決を図るものとします。</p>
          </Article>

          <div style={{ marginTop: 48, paddingTop: 24, borderTop: "1px solid #e8e7e3", fontSize: 13, color: "#6b6b68" }}>
            <div style={{ fontWeight: 700, marginBottom: 8 }}>付則</div>
            <p>2026 年 4 月 21 日：制定・施行</p>
          </div>
        </div>
      </section>

      <PublicFooter minimal />
    </div>
  );
}

function Article({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div style={{ marginBottom: 36 }}>
      <h2 style={{ fontSize: 17, fontWeight: 700, marginBottom: 12, paddingLeft: 12, borderLeft: `3px solid ${PRIMARY}`, color: "#1a1a1a" }}>
        {title}
      </h2>
      <div style={{ fontSize: 14, color: "#4a4a48" }}>
        {children}
      </div>
    </div>
  );
}

const olStyle: React.CSSProperties = {
  paddingLeft: 28,
  margin: "0 0 0 0",
};

const olStyleNested: React.CSSProperties = {
  paddingLeft: 24,
  margin: "8px 0 8px 0",
  listStyleType: "lower-roman",
};

const defList: React.CSSProperties = {
  margin: "12px 0",
};
